import React from "react";
import { MdInventory } from "react-icons/md";
import styles from "./ItemList.module.scss";
import {
  GroupedProduct,
  SaleItemInterface,
} from "../../../../common/types/types";
import { EmptyState } from "../../../../common/components/emptyState/EmptyState";
import GroupItem from "../groupItem/GroupItem";
import Item from "../item/Item";
import { useScrollPagination } from "../../../../common/hooks/useScrollPagination";
import { getCardLayout, getCardStyle } from "../../../../config/runtimeConfig";
import { ItemVariant } from "../../../../common/types/enums";
import { useSelector } from "react-redux";
import { selectCurrentCluster } from "../../../../store/slices/currentClusterSlice";

type Props = {
  items: (SaleItemInterface | GroupedProduct)[];
  getCategoryName: (id: number) => string | undefined;
  isAuth: boolean;
  usingStock: boolean;
  onGroupPress: (group: GroupedProduct) => void;
  emptyStateTitle?: string;
  emptyStateDescription?: string;
  hasMore?: boolean;
  loadingMore?: boolean;
  loadMore?: () => void;
};

export default function ItemList({
  items,
  getCategoryName,
  isAuth,
  usingStock,
  onGroupPress,
  emptyStateTitle = "Список пуст",
  emptyStateDescription = "Товары появятся после добавления",
  hasMore = false,
  loadingMore = false,
  loadMore,
}: Props) {
  const { lastItemRef } = useScrollPagination(hasMore, loadingMore, loadMore);
  const cardLayout = getCardLayout();
  const isList = cardLayout === "list";
 
  const cardStyle = getCardStyle();
  const itemVariant =
    cardStyle === "minimal"
      ? ItemVariant.MINIMAL
      : //@ts-ignore
        cardStyle === "flat"
        ? ItemVariant.FLAT
        : //@ts-ignore
          cardStyle === "wide"
          ? ItemVariant.WIDE
          : ItemVariant.DETAILED;

  if (items.length === 0) {
    return (
      <div className={styles.emptyWrapper}>
        <EmptyState
          icon={MdInventory}
          title={emptyStateTitle}
          description={emptyStateDescription}
        />
      </div>
    );
  }

  return (
    <div className={`${styles.grid} ${isList ? styles.list : ""}`}>
      {items.map((item, index) => {
        if (!item) return null;

        if ("type" in item && item.type === "group") {
          const groupItem = item as GroupedProduct;
          return (
            <div
              key={`group-${groupItem.id}`}
              className={styles.gridItem}
              ref={index === items.length - 1 ? lastItemRef : null}
            >
              <GroupItem
                group={groupItem}
                onPress={() => onGroupPress(groupItem)}
                getCategoryName={getCategoryName}
                isAuth={isAuth}
                usingStock={usingStock}
                variant={itemVariant}
              />
            </div>
          );
        }

        const saleItem = item as SaleItemInterface;
        return (
          <div
            key={`item-${saleItem.id}`}
            className={styles.gridItem}
            ref={index === items.length - 1 ? lastItemRef : null}
          >
            <Item
              item={saleItem}
              getCategoryName={getCategoryName}
              variant={itemVariant}
              isAuth={isAuth}
              usingStock={usingStock}
            />
          </div>
        );
      })}
    </div>
  );
}
